export default {
  isVisible: true,
  isCollapsed: true,
  context: {
    pageType: null,
    pageId: null,
    pageTitle: null,
    data: {}
  },
  messages: [],
  conversationId: null,
  isTyping: false,
  pendingAction: null,
  error: null
};
